"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import ContactButton from "../../components/shared/ContactButton";
export function Header47() {
  return (
    <section 
      
      className="px-[5%] py-16 md:py-24 lg:py-28 max-h-[900px] bg-[rgba(0,0,0,0.5)] h-[550px] w-dvw "
    >
      <div className="container flex items-center md:max-w-5xl lg:max-w-7xl mx-auto ">
        <div className="flex flex-col gap-5 md:flex-col md:gap-5 lg:gap-5 backdrop-blur-[2px] pl-40 -ml-40 text-white  text-shadow-[2px_2px_4px_rgba(0,0,0,0.5)]">
          <div className="w-full max-w-lg">
            <h1 className="font-noto text-5xl font-bold">
            Umfassende Sicherheitsbewertung für Ihr Unternehmen            </h1>
          </div>
          <div className="w-full max-w-lg">
            <p className="md:text-xl md:backdrop-blur-[50px]">
            Unsere Sicherheitsbewertung identifiziert potenzielle Schwachstellen in Ihrer IT-Infrastruktur und bietet Ihnen eine fundierte Risikoanalyse mit konkreten Handlungsempfehlungen
            </p>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
             <ContactButton/>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
